import {Link} from 'react-router-dom';
import React, { useState } from 'react';
import { login, AuthUser } from '../api/auth';
import { EyeIcon, EyeOffIcon } from './PasswordToggleIcons';
import './Login.css';

interface LoginProps {
  onSuccess: (user: AuthUser) => void;
  embedded?: boolean;
}

const Login: React.FC<LoginProps> = ({ onSuccess, embedded }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const user = await login(username.trim(), password);
      onSuccess(user);
    } catch (err: any) {
      setError(err?.message || 'Invalid username or password.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={embedded ? 'login-embedded' : 'login-shell'}>
      <div className="login-card">
        <div className="login-header">
          <span className="login-logo-frame"><img src="/brand/betbuilder-original.png" alt="Betbuilder — we dig the stats" width="2048" height="399" /></span>
          <h2>Welcome back</h2>
          <p>Sign in to your Betbuilder account.</p>
        </div>
        <p role="status">{new URLSearchParams(window.location.search).has("passwordChanged") ? "Password updated. Sign in with your new password." : ""}</p>
        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-field">
            <span>Email</span>
            <input
              type="email"
              autoComplete="username"
              value={username}
              onChange={(event) => {
                setUsername(event.target.value);
                if (error) setError('');
              }}
              placeholder="name@example.com"
              required
            />
          </label>
          <label className="login-field">
            <span>Password</span>
            <div className="password-input">
              <input
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                  if (error) setError('');
                }}
                placeholder="••••••••"
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                title={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
          </label>
          {error && <div className="login-error">{error}</div>}
          <button className="login-submit" type="submit" disabled={submitting}>
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <p><Link to="/recover">Forgot password?</Link></p>
      </div>
      {!embedded && <div className="login-glow" aria-hidden="true" />}
    </div>
  );
};

export default Login;
